import { render } from "./AdministrationTable.vue?vue&type=template&id=3d6092ff"
import script from "./AdministrationTable.vue?vue&type=script&lang=js"
export * from "./AdministrationTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\job\\ems-ISO-final\\frontend_ems\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__